// extracted by mini-css-extract-plugin
export default {"root":"applications-components-common-Description-MobileContents-mobile-contents-module__root","accordeon":"applications-components-common-Description-MobileContents-mobile-contents-module__accordeon"};
    if(module.hot) {
      // 1791528102878
      var cssReload = require("../../../../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  